import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { TermsPage } from "./pages/terms-page";
import "./index.css";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element (#root) was not found in terms.html.");
}

createRoot(rootElement).render(
  <StrictMode>
    <TermsPage />
  </StrictMode>,
);
